import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Icon, Text } from '@leroy-merlin-br/backyard-react-ui'
import { ChevronRight } from '@leroy-merlin-br/backyard-react-icons'

import * as S from './styled'

const SellersListButton = ({ openDrawer, unit }) => {
  const { skus } = useSelector(state => state.skus)
  // TODO: unit pode vir do redux

  const lowerPrice = useMemo(() => {
    if (skus.length) {
      return `${skus[0].price.to.integers},${skus[0].price.to.decimals}`
    }
  }, [skus])

  return (
    <S.Button type="button" onClick={openDrawer}>
      <Text size="kilo" noMargin>
        Mais opções a partir de{' '}
        <Text size="kilo" as="strong" noMargin bold>
          R$ {lowerPrice} /{unit}
        </Text>
      </Text>

      <Icon as={ChevronRight} size="kilo" color="green" />
    </S.Button>
  )
}

SellersListButton.propTypes = {
  openDrawer: PropTypes.func.isRequired,
  unit: PropTypes.string.isRequired
}

export default SellersListButton
